<template>
	<div>
		<cart-item :cart-item="cartItem" :inCart="false">
		</cart-item>
	</div>
</template>
<script>
import CartItem from '../cart/CartItem.vue'
export default {
	props: {
		product: Object,
		cartItem: Object,
	},
	components: {
		CartItem
	},
	data() {
		return {
		};
	},
};
</script>

<style scoped lang="scss">
.total-price {
	font-size: 18px;
	font-weight: 700;
	line-height: 24px;

	&__price {
		font-size: 22px;
		font-weight: 700;
		line-height: 20px;
	}
}
</style>